"use strict";

import {getPrefixedDataSet} from "@c0necto/elements-data-set-utils";
import {onFind} from "@c0necto/elements-init-modules-in-scope";
import {findIn, findAllIn, setText} from '@c0necto/elements-dom-utils'
import throwError from "@c0necto/elements-throw-error";


const defaultSelectors = {
    base: '.js-range-slider',
    slider: '.js-range-slider__slider',
    inputMin: '.js-range-slider__min',
    inputMax: '.js-range-slider__max'
};


const defaultOptions = {
    range: {
        min: 0,
        max: 100
    },
    start: [0, 100],
    step: 1,
    connect: true
};

export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        createRangeSlider(
            baseElement,
            {...defaultOptions, ...options},
            {...defaultSelectors, ...selectors}
        );
    });
}

export function createRangeSlider(baseElement, options = defaultOptions, selectors = defaultSelectors) {
    import('nouislider').then(function (noUiSlider) {
        let slider = baseElement;

        options = {
            ...defaultOptions,
            ...options,
            ...transformDataSetOptions(getPrefixedDataSet('range-slider', slider))

        };

        let sliderElement = findIn(selectors.slider, slider),
            minInput = findIn(selectors.inputMin, slider),
            maxInput = findIn(selectors.inputMax, slider),
            decimalPlaces = 0;

        if (options.step < 1) {
            decimalPlaces = options.step.toString().length - 2;
        }

        noUiSlider.create(sliderElement, options);

        sliderElement.noUiSlider.on('update', (values, handle) => {
            let value = +values[handle];

            if ( handle === 0 ) {
                findAllIn('.js-range-slider__val-min', slider).forEach(setText(value));
                minInput.value = value.toFixed(decimalPlaces);
            } else {
                findAllIn('.js-range-slider__val-max', slider).forEach(setText(value));
                maxInput.value = value.toFixed(decimalPlaces);
            }

            call(options.onUpdate, {
                element: slider,
                value,
                decimalPlaces,
                handle
            });
        });

        sliderElement.noUiSlider.on('set', (values, handle) => {
            call(options.onSet, {
                element: slider,
                values,
                decimalPlaces,
                handle
            });
        });
    });
}

function transformDataSetOptions(options = {}) {
    let transformedOptions = {...options};

    if (transformedOptions.range) {
        try {
            transformedOptions.range = JSON.parse(transformedOptions.range)
        } catch (e) {
            transformedOptions.range = null;
            throwError(RANGE_ERROR_MESSAGE);
        }
    }

    if (transformedOptions.start) {
        try {
            transformedOptions.start = JSON.parse(transformedOptions.start)
        } catch (e) {
            transformedOptions.start = null;
            throwError(START_ERROR_MESSAGE);
        }
    }

    if (transformedOptions.step) {
        transformedOptions.step = parseFloat(transformedOptions.step);
    }

    if (transformedOptions.margin) {
        transformedOptions.margin = parseFloat(transformedOptions.margin);
    }

    return transformedOptions;
}

const RANGE_ERROR_MESSAGE = `Range-Slider error: data-range-slider-range has to be a a valid JSON object. Most likely you used single quotes instead of double quotes for the JSON fields.`;
const START_ERROR_MESSAGE = `Range-Slider error: data-range-slider-start has to be a a valid JSON object. Most likely you used single quotes instead of double quotes for the JSON fields.`;

function call(fnc, ...params) {
    if (fnc && typeof fnc === 'function') {
        fnc(...params);
    }
}
